import { DEVICE_ID } from 'constants';
import Cookies from 'helpers/cookies';
import { useEffect } from 'react';
import { v4 as uuidv4 } from 'uuid';

const useDeviceId = () => {
  const deviceId = Cookies.get(DEVICE_ID);
  useEffect(() => {
    if (deviceId) return;
    const uuid = uuidv4();
    if (uuid) {
      Cookies.set(DEVICE_ID, `${uuid}`);
    }
  }, [deviceId]);
};

export default useDeviceId;
